import React from 'react';
import type { IframeConfig } from './types';

interface IframeEmbedProps {
  config: IframeConfig;
  lazyLoad?: boolean;
}

/** HTML width/height attributes ignore "%" and "px", so size the iframe with CSS. */
function toCssSize(value: string | undefined, fallback: string): string {
  if (!value) return fallback;
  return /^\d+(\.\d+)?$/.test(value) ? `${value}px` : value;
}

export const IframeEmbed: React.FC<IframeEmbedProps> = ({ config, lazyLoad }) => {
  const sandboxAttr = config.sandbox?.join(' ');

  return (
    <iframe
      src={config.src}
      title={config.title || 'Embedded content'}
      style={{
        width: toCssSize(config.width, '100%'),
        height: toCssSize(config.height, '400px'),
      }}
      frameBorder={config.frameBorder ? 1 : 0}
      scrolling={config.scrolling}
      allowFullScreen={config.allowFullscreen}
      sandbox={sandboxAttr}
      allow={config.allow}
      loading={lazyLoad ? 'lazy' : undefined}
    />
  );
};
